import { render, staticRenderFns } from "./search-box-processing.vue?vue&type=template&id=350e6f1e&scoped=true"
import script from "./search-box-processing.vue?vue&type=script&lang=js"
export * from "./search-box-processing.vue?vue&type=script&lang=js"
import style0 from "./search-box-processing.vue?vue&type=style&index=0&id=350e6f1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350e6f1e",
  null
  
)

export default component.exports